__turbopack_context__.v({
  "advert-two-columns": "Listing-module-sass-module__yHQs4G__advert-two-columns",
  "advertListing": "Listing-module-sass-module__yHQs4G__advertListing",
  "card": "Listing-module-sass-module__yHQs4G__card",
  "columnAdvert": "Listing-module-sass-module__yHQs4G__columnAdvert",
  "gigAssist": "Listing-module-sass-module__yHQs4G__gigAssist",
  "pagination": "Listing-module-sass-module__yHQs4G__pagination",
  "rest-list-grid": "Listing-module-sass-module__yHQs4G__rest-list-grid",
  "rest-list-layout": "Listing-module-sass-module__yHQs4G__rest-list-layout",
  "wrapper": "Listing-module-sass-module__yHQs4G__wrapper",
});
